import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

export function CallbackPage() {
    const auth = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (!auth.isLoading && auth.isAuthenticated) {
            navigate("/", { replace: true });
        }
    }, [auth.isLoading, auth.isAuthenticated, navigate]);
    if (auth.error) {
        return (
            <div className="flex min-h-screen items-center justify-center p-8">
                <p className="text-sm text-destructive">{auth.error.message}</p>
            </div>
        );
    }
    return (
        <div className="flex min-h-screen items-center justify-center">
            <p className="text-sm text-muted-foreground">Completing sign-in…</p>
        </div>
    );
}
